import { VehicleInfoModel } from '@/types/api'
import styles from './VehicleInfo.module.scss'
import React, { useState } from 'react'
import classNames from 'classnames'
import ArrowLineIcon from '@/assets/svg/arrow-line.svg'
import { useTranslation } from 'next-i18next'

type Props = {
  info: VehicleInfoModel
}

const DetailsSection = ({ details }: { details: { label: string, value: string }[] }) => (
  <div className={classNames('col-xs-12 col-md-6', styles.detailsSection)}>
    {details.map((detail, index) => (
      <div key={index} className={classNames('row', styles.detailRow)}>
        <div className={classNames('col-xs-6 col-md-3', styles.detailsLabel)}>{detail.label}</div>
        <div className="col-xs-6">{detail.value}</div>
      </div>
    ))}
  </div>
)

const VehicleInfo = ({ info }: Props) => {
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation('common')

  const toggleOpen = () => {
    setOpen(!open)
  }

  const formatValue = (front: any, back?: any): string => {
    if (back && front !== back) {
      return `${t('vehicleInfo.front')} ${front} / ${t('vehicleInfo.back')} ${back}`
    }
    return front
  }

  const boltNutText = () => {
    const nutOrBolt = info.chassi.nutOrbolt === 'bolt' ? t('vehicleInfo.bolt') : t('vehicleInfo.nut')

    return `${nutOrBolt} ${info.chassi.nutBoltThreadType}/${info.chassi.boltLength}`
  }

  const details = [
    { label: t('vehicleInfo.centerBore'), value: info.chassi.centreBore.toString() },
    { label: t('vehicleInfo.boltPattern'), value: info.chassi.pcd },
    { label: t('vehicleInfo.boltOrNut'), value: boltNutText() },
    { label: t('vehicleInfo.tpms'), value: info.chassi.tpms ? t('yes') : t('no') },
  ]

  const tyreDetails = [
    { label: t('vehicleInfo.tyreSize'), value: formatValue(info.wheel.tyreSize, info.wheel.tyreSizeR) },
    { label: t('vehicleInfo.loadIndex'), value: formatValue(info.wheel.loadIndex, info.wheel.loadIndexR) },
    { label: t('vehicleInfo.speedIndex'), value: info.wheel.speedIndex },
    { label: t('vehicleInfo.tyrePressure'), value: formatValue(info.wheel.tyrePressure, info.wheel.tyrePressureR) },
    { label: t('vehicleInfo.rimSize'), value: formatValue(info.wheel.rimSize, info.wheel.rimSizeR) },
    { label: t('vehicleInfo.rimOffset'), value: formatValue(info.wheel.rimOffset, info.wheel.offsetR) },
  ]

  return (
    <div className={classNames(styles.component, { [styles.open]: open })} onClick={toggleOpen}>
      <div className={styles.vehicleName}>
        <span>{t('vehicleInfo.vehicleModel')}</span> {info.manufactureName} {info.modelName} ({info.vehicle.fromYear} - {info.vehicle.toYear || ''}) {info.vehicle.carName}
      </div>
      <div className={classNames(styles.arrow, { [styles.up]: open })}>
        <ArrowLineIcon />
      </div>
      <div className={classNames(styles.details, 'row')}>
        <DetailsSection details={tyreDetails} />
        <DetailsSection details={details} />
      </div>
    </div>
  )
}

export default VehicleInfo